module.exports = __webpack_public_path__ + "static/img/icon h wordys 1.3ac99b50.svg";